var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from "react";
import styled from "styled-components";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var opacity = _a.opacity, isActive = _a.isActive;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.9rem;\n  opacity: ".concat(opacity, ";\n  cursor: pointer;\n  border: 1px solid").concat(isActive ? "" : " rgba(0,0,0,0)", ";\n\n\n  &:hover {\n    border: 1px solid;\n  }\n  ");
});
export var Day = function (_a) {
    var value = _a.value, _b = _a.opacity, opacity = _b === void 0 ? 1 : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c, onClick = _a.onClick;
    var handleClick = useCallback(function (e) {
        if (onClick) {
            onClick(value, e);
        }
    }, [onClick, value]);
    return (React.createElement(Wrapper, { onClick: handleClick, opacity: opacity, isActive: isActive }, value.getDate()));
};
var templateObject_1;
